import AuthorizationWrapper, {
  authFnAllowAdminImplementationManagerOrSASupervisor,
} from '@product-framework/components/AuthorizationWrapper';
import { getRoutes } from '@ui-framework/index';
import NotificationSettingsPage from './pages/settings';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

const Pages = ProtectedRoute => ({
  NotificationSettingsPage: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowAdminImplementationManagerOrSASupervisor],
      }}
      Component={NotificationSettingsPage}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

export { NotificationSettingsPage, routes };
